// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","feedItemsPanelHeader":"_1-zRAYthkv3CDmq5uKby1E","fundProfileReturnsEdit":"_yH3faNzMPmAeAAVeN6nN","tabNav":"Yulj3gbg2Ab7ByccziEkP"};